import React, { useContext } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import { FormattedMessage, useIntl } from "react-intl"
import { Box, Button, Link, Stack, Typography, useTheme } from "@carrotfertility/carotene-core"
import { CarrotCardCostSharePreAuthContext } from "#/components/carrot-card-cost-share/state/CarrotCardCostSharePreAuthContext"
import { CostShareAmountBox } from "#/components/carrot-card-cost-share/steps/shared/CostShareAmountBox"
import { Link as RouterLink } from "react-router-dom"
import { Paths } from "#/utils/Paths"
import { getAmountsAndDates } from "#/components/carrot-card-cost-share/steps/shared/getAmountsAndDates"

export function CarrotCardReadyToUseStep(): JSX.Element {
  const theme = useTheme()
  const { send } = useStateMachine()
  const { preAuthResponse } = useContext(CarrotCardCostSharePreAuthContext)
  const intl = useIntl()

  const { carrotCardAmount, personalPaymentAmount, expirationDate } = getAmountsAndDates(preAuthResponse, intl)

  return (
    <Box>
      <Box sx={(theme) => ({ display: "flex", justifyContent: "center", marginBlockEnd: theme.tokens.spacing.md })}>
        <Box
          component="img"
          src="/images/illo-carrot-cards.png"
          srcSet="/images/illo-carrot-cards-2x.png"
          alt=""
          sx={{ blockSize: "200px", inlineSize: "200px" }}
        />
      </Box>
      <Typography
        id="submit-authorization-title"
        variant="h3"
        sx={(theme) => ({ marginBlockEnd: theme.tokens.spacing.xs })}
      >
        <FormattedMessage defaultMessage="Your Carrot Card is ready to use. " />
      </Typography>

      <Stack spacing={theme.tokens.spacing.md}>
        <Typography>
          <FormattedMessage
            defaultMessage="Pay the provider or merchant the amounts below by {expirationDate}. "
            values={{ expirationDate }}
          />
        </Typography>

        {personalPaymentAmount ? (
          <Typography>
            <FormattedMessage defaultMessage="The Carrot Card charge must be completed in a single transaction. This amount will be deducted from your Carrot funds after you use your card. " />
          </Typography>
        ) : null}

        <CostShareAmountBox carrotCardAmount={carrotCardAmount} personalPaymentAmount={personalPaymentAmount} />

        <Typography>
          <FormattedMessage
            defaultMessage="We’ve sent you an email with more information. If you have questions, <link>contact us</link>."
            values={{
              link: (linkContent) => (
                <Link
                  component={RouterLink}
                  to={Paths.CARE_TEAM}
                  color="inherit"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {linkContent}
                </Link>
              )
            }}
          />
        </Typography>

        <Box
          sx={(theme) => ({
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            marginBlockStart: theme.tokens.spacing.md
          })}
        >
          <Button variant="contained" color="primary" onClick={() => send("CLOSE")}>
            <FormattedMessage defaultMessage="Close" />
          </Button>
        </Box>
      </Stack>
    </Box>
  )
}
